export default __webpack_public_path__ + "static/img/shadow_onface_pic.2c494e1.svg";